export default class companyManager {
    constructor() {
        this.moreBtn = document.querySelector('.more-btn');
        this.more = document.querySelectorAll('.more');

        this.$rootLoad = document.getElementById("l-root-load");
    }

    init() {
        this.moreBtn.addEventListener('click',()=>{
            this.open();
        });
    }

    open(){
        TweenMax.to(this.more,1,{
            display: 'table-row',
            opacity: 1,
            ease: Power2.easeOut,
            onComplete:()=>{
                this.resize();
            }
        });
        TweenMax.set(this.moreBtn,{
           display: 'none',
           opacity: 0
        });
    }

    resize(){
        document.body.style.height = this.$rootLoad.clientHeight + 'px';
    }
}